import React from "react";
import { Button, Tooltip } from "@mui/material";
import HighlightWrapper from "./HighlightWrapper";
import { WarningSquareSolid } from "iconoir-react";
import { usePermissionAction } from "../hooks/usePermissionAction";

type MarkerUpdateButtonProps = {
  onClick: () => void;
  disabled: boolean;
  markerCode?: string;
};

const MarkerUpdateButton: React.FC<MarkerUpdateButtonProps> = ({
  onClick,
  disabled,
  markerCode,
}) => {
  const checkAmlUpdatePermission = usePermissionAction("update:investor-aml");
  return (
    <div style={{ position: "relative" }}>
      <Button
        id={markerCode}
        size="small"
        variant="outlined"
        sx={{
          borderRadius: "4px",
          padding: "3px 9px",
          fontSize: "0.8125rem",
        }}
        disabled={disabled}
        onClick={checkAmlUpdatePermission(onClick)}
      >
        Update
      </Button>
      <HighlightWrapper type="Marker" id={markerCode}>
        {(isHighlighted, highlightedItem) => {
          return isHighlighted ? (
            <Tooltip title={highlightedItem?.message}>
              <WarningSquareSolid
                style={{
                  color: "#faad14",
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  marginLeft: "10px",
                }}
              />
            </Tooltip>
          ) : null;
        }}
      </HighlightWrapper>
    </div>
  );
};

export default MarkerUpdateButton;
